import React from 'react';

import { ScreenReaderService } from '../services/ScreenReaderService';

export function ScreenReader(): JSX.Element {
    const [screenReaderMessage, setScreenReaderMessage] = React.useState('');
    React.useEffect(() => {
        const announceScreenReaderMessage = (newScreenReaderMessage: string) => {
            setScreenReaderMessage(newScreenReaderMessage);
        };
        ScreenReaderService.instance.addScreenReaderMessageHandler(announceScreenReaderMessage);
        return () => {
            ScreenReaderService.instance.removeScreenReaderMessageHandler(announceScreenReaderMessage);
        };
    }, []);
    return (
        <div className="sr-only" aria-live="polite" data-tb-test-id = "site-space-screen-reader">
            {screenReaderMessage}
        </div>
    );
}
